import { createRouter, createWebHistory } from 'vue-router'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      name: 'HomePage',
      component: () => import('@/views/home/HomeView.vue'),
    },
    {
      path: '/mon-histoire',
      name: 'AboutPage',
      component: () => import('@/views/about/AboutView.vue'),
    },
    {
      path: '/contact',
      name: 'ContactPage',
      component: () => import('@/views/contact/ContactView.vue'),
    },
    {
      path: '/experience/bainsonore',
      name: 'HealingPage',
      component: () => import('@/views/experiences/healing/HealingView.vue'),
    },
    {
      path: '/experience/breathwork',
      name: 'BreathworkPage',
      component: () => import('@/views/experiences/breathwork/BreathworkView.vue'),
    },
    {
      path: '/retraites-immersives',
      name: 'SecondSoufflePage',
      component: () => import('@/views/experiences/retirement/RetirementView.vue'),
    },
    {
      path: '/online',
      name: 'OnlinePage',
      component: () => import('@/views/online/OnlineView.vue'),
    },
    {
      path: '/partenariats',
      name: 'PartnershipsPage',
      component: () => import('@/views/partnerships/PartnershipsView.vue'),
    },
    {
      path: '/professionel',
      name: 'ProfessionalPage',
      component: () => import('@/views/professional/ProfessionalView.vue'),
    },
    {
      path: '/success-retraite',
      name: 'SuccessPage',
      component: () => import('@/views/success/successView.vue'),
    },

    {
      path: '/mentions-legales',
      name: 'MentionsPage',
      component: () => import('@/views/mentions/MentionsView.vue'),
    },
    {
      path: '/cgv',
      name: 'CgvPage',
      component: () => import('@/views/cgv/CgvView.vue'),
    },
    {
      path: '/charte',
      name: 'ChartePage',
      component: () => import('@/views/charte/CharteView.vue'),
    },
    {
      path: '/confidentialite',
      name: 'PrivacyPage',
      component: () => import('@/views/privacy/PrivacyView.vue'),
    },

    {
      path: '/:pathMatch(.*)*',
      name: 'not-found',
      component: () => import('@/views/not-found/NotFoundView.vue')
    }

  ],
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      return {
        el: to.hash,
        behavior: 'smooth',
      }
    }
    return { top: 0 }
  },
})

export default router
